export const enTranslations = {
  hello: 'Hello!',
  adelGreet: ' Welcome to Ministry of Justice, Kuwait',
  adelIntro:
    "I'm here to answer your questions about everything related to Ministry of Justice, Kuwait website, including legal procedures.",
  talk: 'Start Talking',
  startTyping: 'Start Typing...',
  en: 'English',
  ar: 'AR',
  connecting: 'Connecting',
  tapMic: 'Tap on the mic to speak',
  poweredBy: 'Powered By',
  adel: 'Adel',
  askByVoice: 'Ask by Voice',
  askByText: 'Ask by Text',
  backToChat: 'Back To Chat',
  backToHome: 'Back To Home',
  talkTo: 'Talk to ',
  noor: 'Noor',
  loading: 'Loading...',
  back: 'Back',
  researching: 'Researching...',
  talking: 'Talking...',
  adelTalking: 'Talking...',
  noorTalking: 'Talking...',
  adelListening: 'Listening...',
  noorListening: 'Listening...',
  tapToTalk: 'Tap to Talk',
  tapToPause: 'Tap to Pause',
};
